// @flow

import styles from './SeoFooter.less';

import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

import { Hidden, Section, PageBlock } from 'seek-style-guide/react';
import RelatedSearches from './RelatedSearches/RelatedSearches';
import SeoBlurb from './SeoBlurb/SeoBlurb';
import SeoPartners from './SeoPartners/SeoPartners';
import Suburbs from './Suburbs/Suburbs';

import { getBlurb } from '@seek/seek-jobs-seo';
import { includedKeyword } from '@seek/related-search-seo/dist/keyword-filters';

type PartnersType = {
  canCrossLink: boolean,
  href?: ?string,
  label?: ?string
};

type PropTypes = {
  className?: string,
  locale: Locale,
  pageNumber: number,
  partners: PartnersType,
  pathname: string,
  relatedSearches?: Array<RelatedSearchKeyword>,
  searchQuery: SearchParams,
  suburbs: Array<string>
};

function mapStateToProps({ search, results }) {
  return {
    searchQuery: search.query,
    suburbs: results.results ? results.results.suburbs : [],
    partners: results.joraCrossLink || { canCrossLink: false }
  };
}

const SeoFooter = ({
  relatedSearches = [],
  className = '',
  ...props
}: PropTypes) => {
  const {
    locale,
    searchQuery,
    pathname,
    pageNumber,
    suburbs,
    partners
  } = props;

  const blurb = getBlurb({ ...{ locale, pathname, pageNumber } });
  const { canCrossLink, href, label } = partners;
  const filteredSearches: Array<RelatedSearchKeyword> = relatedSearches.filter(
    ({ keywords }) => includedKeyword(keywords)
  );

  const shouldRenderSeoBlurb = Boolean(blurb.length);
  const shouldRenderRelatedSearches = Boolean(filteredSearches.length);
  const shouldRenderSuburbs = suburbs.length && suburbs.length >= 2;
  const shouldRenderSeoPartners = canCrossLink;

  const isSomethingToRender =
    shouldRenderSeoBlurb ||
    shouldRenderRelatedSearches ||
    shouldRenderSuburbs ||
    shouldRenderSeoPartners;

  return isSomethingToRender ? (
    <Hidden
      component={PageBlock}
      mobile
      className={classnames([styles.colors, className])}
    >
      <Section header className={styles.sidePadding}>
        {shouldRenderSeoBlurb ? (
          <SeoBlurb {...{ locale, pathname, pageNumber, blurb }} />
        ) : null}
        {shouldRenderRelatedSearches ? (
          <RelatedSearches filteredSearches={filteredSearches} />
        ) : null}
        {shouldRenderSuburbs ? <Suburbs {...{ suburbs, searchQuery }} /> : null}
        {shouldRenderSeoPartners ? <SeoPartners {...{ href, label }} /> : null}
      </Section>
    </Hidden>
  ) : null;
};

export default connect(mapStateToProps)(SeoFooter);
